import { createWithEqualityFn } from 'zustand/traditional'; // Use the recommended function
import { shallow } from 'zustand/shallow';
import { AddFamilyMemberPersonalDetailsData } from '@/lib/validation';

type State = {
  personalDetails: AddFamilyMemberPersonalDetailsData | null;
};

type Actions = {
  setData: (data: Partial<State>) => void;
  resetData: (data?: (keyof State)[]) => void;
};

const initialState: State = {
  personalDetails: null,
};

const useAddFamilyMemberStoreBase = createWithEqualityFn<State & Actions>()(set => ({
  ...initialState,
  setData: data =>
    set(state => ({
      ...state,
      ...data,
    })),
  resetData: data =>
    set(state => {
      if (!data) return initialState;

      data.forEach((name: keyof State) => {
        if (Object.prototype.hasOwnProperty.call(initialState, name)) {
          // Ensure proper typing with type assertion
          state[name] = initialState[name] as State[typeof name];
        }
      });

      return state;
    }),
}));

export const useAddFamilyMemberStore = <U>(
  selector: (state: State & Actions) => U
) => {
  return useAddFamilyMemberStoreBase(selector, shallow);
};
